/* ============================================================
   BIANCO — البيانات لايف من شوبيفاي
   ملف الكتالوج (bianco-data.js) بيتبني بسكريبت، فأي تعديل في الأدمن
   مكانش بيبان غير بعد تحديث. الملف ده بيجيب المنتجات لايف من
   /collections/all?view=bn-live ويحدّث window.CAT في مكانه، وبعدين كل جزء
   بيعيد الرسم. الكتالوج الثابت بيفضل احتياطي لو الطلب فشل أو اتأخر.

   القواعد (البراند، اللون، المقاسات، القسم) نفس build-catalog.py بالظبط —
   لو اتغيّرت هناك لازم تتغيّر هنا.
   ============================================================ */
(function () {
  var C = window.CAT = window.CAT || {};
  var ready = false, waiters = [], TIMEOUT = 3500;

  // كل جزء بيسجّل نفسه هنا: بيترسم أول ما البيانات اللايف توصل، أو بعد
  // ٣.٥ ثانية بالثابت لو اتأخرت — وبيترسم تاني لو وصلت بعد كده
  window.bnWhenLive = function (fn) {
    waiters.push(fn);
    if (ready) { try { fn(); } catch (e) { if (window.console) console.error('bn render', e); } }
  };
  function fire() {
    ready = true;
    waiters.forEach(function (fn) { try { fn(); } catch (e) { if (window.console) console.error('bn render', e); } });
  }
  var timer = setTimeout(function () { if (!ready) fire(); }, TIMEOUT);

  // نفس ترتيب COLS في build-catalog.py — لو اتغيّر هناك لازم يتغيّر هنا
  var COLS = [['jackets', 'Jackets & Coats', 'جاكتس'], ['hoodies', 'Hoodies', 'هوديز'],
    ['sweatshirts', 'Sweatshirts', 'سويت شيرت'],
    ['t-shirt', 'T-Shirts', 'تيشيرتات'], ['polo', 'Polo Shirts', 'بولو'], ['shirts', 'Shirts', 'قمصان'],
    ['pants', 'Trousers & Denim', 'بناطيل وجينز'], ['sneakers', 'Sneakers', 'سنيكرز'],
    ['short', 'Swim Shorts', 'مايوهات'], ['perfume-gallery', 'Perfume', 'عطور'],
    ['full-set', 'Full Set', 'فل سيت'],
    ['big-size', 'Big Size', 'مقاسات كبيرة'], ['caps', 'Caps', 'كابات'], ['bags-1', 'Bags', 'شنط']];
  var BRANDS = ['BRUNELLO CUCINELLI', 'YVES SAINT LAURENT', 'DOLCE & GABBANA', 'POLO RALPH LAUREN',
    'CHRISTIAN DIOR', 'TOMMY HILFIGER', 'LOUIS VUITTON', 'LOUIS VUTTION', 'PAUL & SHARK', 'SAINT LAURENT',
    'RALPH LAUREN', 'PACO RABANNE', 'PURPLE BRAND', 'GOLDEN GOOSE', 'PAUL&SHARK', 'STONE ISLAND',
    'PHILIPP PLEIN', 'CALVIN KLEIN', 'TRUE RELIGION', 'EMPORIO ARMANI', 'PALM ANGELS', 'LORO PIANA',
    'CASABLANCA', 'JIL SANDER', 'FRED PERRY', 'JACQUEMUS', 'HUGO BOSS', 'OFF-WHITE', 'AMI PARIS',
    'BALENCIAGA', 'ALLSAINTS', 'GIVENCHY', 'DSQUARED2', 'TOM FORD', 'DSQUARED', 'BURBERRY', 'VALENTINO',
    'MIU MIU', 'MONCLER', 'LACOSTE', 'BALMAIN', 'VERSACE', 'ICEBERG', 'HERMÈS', 'HERMES', 'ARMANI', 'PURPLE',
    'LOEWE', 'KENZO', 'AMIRI', 'GUCCI', 'PRADA', 'ZEGNA', 'CELINE', 'DIOR', 'BOSS', 'HUGO', 'GUESS', 'FENDI',
    'CHRISTIAN LOUBOUTIN', 'LOUBOUTIN', 'FEAR OF GOD', 'ESSENTIALS', 'CAMP',
    'NIKE', 'Y-3', 'POLO', 'LV', 'AMI'];
  var CANON = { 'HERMES': 'HERMÈS', 'CHRISTIAN DIOR': 'DIOR', 'RALPH LAUREN': 'POLO RALPH LAUREN',
    'POLO': 'POLO RALPH LAUREN', 'EMPORIO ARMANI': 'ARMANI', 'DSQUARED': 'DSQUARED2',
    'YVES SAINT LAURENT': 'SAINT LAURENT', 'PAUL&SHARK': 'PAUL & SHARK', 'HUGO': 'HUGO BOSS',
    'BOSS': 'HUGO BOSS', 'PURPLE': 'PURPLE BRAND', 'LV': 'LOUIS VUITTON', 'LOUIS VUTTION': 'LOUIS VUITTON',
    LOUBOUTIN: 'CHRISTIAN LOUBOUTIN', AMI: 'AMI PARIS' };
  var GENERIC = { 'POLO': 1, 'BOSS': 1, 'HUGO': 1, 'PURPLE': 1, 'LV': 1 };
  // الترتيب مهم: لو لونين في نفس المكان، الأول هو اللي بيكسب
  var COLOR = [['black', ['jet black', 'black', 'noir'], 'أسود'],
    ['white', ['off white', 'white', 'cream', 'ivory', 'ecru'], 'أبيض'],
    ['navy', ['navy', 'midnight', 'dark blue'], 'كحلي'], ['blue', ['light blue', 'denim', 'indigo', 'blue'], 'أزرق'],
    ['grey', ['charcoal', 'anthracite', 'grey', 'gray', 'silver'], 'رمادي'],
    ['beige', ['beige', 'sand', 'camel', 'khaki', 'taupe', 'tan'], 'بيج'], ['green', ['olive', 'green'], 'أخضر'],
    ['red', ['burgundy', 'bordeaux', 'red'], 'أحمر'], ['brown', ['chocolate', 'brown'], 'بني'],
    ['yellow', ['mustard', 'yellow'], 'أصفر'], ['pink', ['pink'], 'وردي'], ['orange', ['orange'], 'برتقالي'],
    ['purple', ['purple'], 'بنفسجي']];
  var SZ = { small: 'S', s: 'S', medium: 'M', m: 'M', large: 'L', l: 'L', xlarge: 'XL', xl: 'XL',
    extralarge: 'XL', xxlarge: 'XXL', xxl: 'XXL', '2xlarge': 'XXL', '2xl': 'XXL', xxxlarge: '3XL',
    '3xlarge': '3XL', '3xl': '3XL', xxxl: '3XL', xsmall: 'XS', xs: 'XS', onesize: 'ONE SIZE' };
  var WORD = '[A-Za-z0-9_\\u00C0-\\u024F]';

  function reEsc(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  // الكتابة من غير مسافات أو علامات: "Dolce&Gabbana" و "Off- white"
  var SQ = BRANDS.map(function (b) { return [b.replace(/[^A-Z0-9]/g, ''), b]; })
    .filter(function (x) { return x[0].length >= 6 && !GENERIC[x[1]]; })
    .sort(function (a, b) { return b[0].length - a[0].length; });
  function detect(T) {
    var i, b;
    for (i = 0; i < BRANDS.length; i++) if (T.indexOf(BRANDS[i]) === 0) return BRANDS[i];
    for (i = 0; i < BRANDS.length; i++) {
      b = BRANDS[i]; if (GENERIC[b]) continue;
      if (new RegExp('(^|(?!' + WORD + ').)' + reEsc(b) + '(?!' + WORD + ')').test(T)) return b;
    }
    var t = T.replace(/[^A-Z0-9]/g, '');
    for (i = 0; i < SQ.length; i++) if (t.indexOf(SQ[i][0]) >= 0) return SQ[i][1];
    return null;
  }
  var EDGE = /^[ \-–—]+|[ \-–—]+$/g;
  function clean(title) {
    title = String(title || '');
    var raw = detect(title.toUpperCase()), n = title;
    var label = raw ? (CANON[raw] || raw) : 'BIANCO';
    if (raw) {
      var vs = [raw]; if (CANON[raw] && CANON[raw] !== raw) vs.push(CANON[raw]);
      vs.sort(function (a, b) { return b.length - a.length; });
      vs.forEach(function (v) {
        n = n.replace(new RegExp('^\\s*' + reEsc(v) + '(?!' + WORD + ')', 'i'), '').replace(EDGE, '');
      });
      n = n.replace(/^(men'?s|mens)\s+/i, '').replace(EDGE, '');
    }
    n = n.replace(/\s*[–—]\s*/g, ' — ').replace(/\s+/g, ' ').trim();
    if (n.length < 4) n = title;
    return [label, n.charAt(0).toUpperCase() + n.slice(1)];
  }
  function norm(v) {
    var x = String(v).trim().toLowerCase().replace(/[\s\-_.]+/g, '');
    return SZ[x] || String(v).trim().toUpperCase();
  }
  function colorOf(t) {
    t = t.toLowerCase(); var best = null, pos = 1e9;
    COLOR.forEach(function (c) {
      c[1].forEach(function (k) { var i = t.indexOf(k); if (i >= 0 && i < pos) { pos = i; best = c[0]; } });
    });
    return best;
  }
  // /cdn/shop/files/NAME → نفس شكل الكتالوج (~NAME) عشان im() في باقي الملفات تشتغل زي ما هي
  var SHOP = String(C.pre || 'https://cdn.shopify.com/s/files/1/0798/4961/9746/files/').replace(/files\/$/, '');
  function img(u) {
    var m = String(u || '').match(/\/cdn\/shop\/(files|products)\/([^?#]+)/);
    if (m) return m[1] === 'files' && C.pre ? '~' + m[2] : SHOP + m[1] + '/' + m[2];
    return u && u.indexOf('//') === 0 ? 'https:' + u : u;
  }

  function product(x, old) {
    var tb = clean(x.title);
    var s = (x.s || []).filter(function (v) { return v[0] !== 'Default Title'; });
    if (!s.length) s = [['One size', 1]];
    s = s.slice(0, 10);
    var p = { h: x.h, t: tb[1], b: tb[0], p: x.p / 100, c: x.c ? x.c / 100 : null,
      i: (x.i || []).slice(0, 2).map(img), s: s, d: String(x.d || '').replace(/\s+/g, ' ').trim(),
      cr: x.cr || '', ar: x.ar || 1, w: old && old.w != null ? old.w : 2 };
    var cols = x.cols || [], home = null;
    for (var k = 0; k < COLS.length && !home; k++) if (cols.indexOf(COLS[k][0]) >= 0) home = COLS[k][0];
    p.col = home || (old && old.col) || 't-shirt';
    var cc = colorOf(p.t + ' ' + p.d); if (cc) p.col_ = cc;
    var seen = {}; p.sz = [];
    s.forEach(function (v) { if (v[1]) { var z = norm(v[0]); if (!seen[z]) { seen[z] = 1; p.sz.push(z); } } });
    p.sz.sort();
    var colName = ''; COLS.forEach(function (c) { if (c[0] === p.col) colName = c[1]; });
    p.q = [p.t, p.b, p.col_ || '', colName].join(' ').toLowerCase();
    p.clr = cols.indexOf('clearance') >= 0;
    p.cols = cols;                          // كل أقسام القطعة — لشارة "لحد X٪" على المربعات
    return p;
  }

  // ترتيب شوبيفاي للقسم لو اتجاب؛ اللي مش فيه بيتحط في الآخر بترتيبه القديم
  function byOrder(handle, arr) {
    var o = ORDER[handle]; if (!o) return arr;
    var pos = {}; o.forEach(function (h, i) { pos[h] = i; });
    return arr.slice().sort(function (a, b) {
      return (pos[a.h] == null ? 1e9 : pos[a.h]) - (pos[b.h] == null ? 1e9 : pos[b.h]); });
  }

  function merge(list) {
    var P = C.products = C.products || {}, live = {};
    list.forEach(function (x) {
      if (!x || !x.av || !x.i || !x.i.length) return;       // زي الكتالوج: متاح وعنده صورة
      live[x.h] = product(x, P[x.h]);
    });
    Object.keys(P).forEach(function (h) { if (!live[h]) delete P[h]; });
    Object.keys(live).forEach(function (h) { P[h] = live[h]; });
    var all = Object.keys(P).map(function (h) { return P[h]; });
    var newest = function (a, b) { return a.cr < b.cr ? 1 : a.cr > b.cr ? -1 : 0; };

    // الأوكازيون = قسم Clearance في شوبيفاي
    var clr = byOrder('clearance', all.filter(function (p) { return p.clr; }).sort(function (a, b) { return b.p - a.p; }));
    C.clearance = C.clearance || { pct: 0, items: [] };
    C.clearance.items.length = 0;
    clr.forEach(function (p) { C.clearance.items.push(p.h); });
    var CS = {}; clr.forEach(function (p) { CS[p.h] = 1; });

    C.cols = COLS.map(function (c) {
      var items = byOrder(c[0], all.filter(function (p) { return p.col === c[0] && !CS[p.h]; }).sort(newest));
      return items.length ? { h: c[0], en: c[1], ar: c[2], n: items.length, img: items[0].i[0],
        items: items.map(function (p) { return p.h; }) } : null;
    }).filter(Boolean);

    var cnt = {}; all.forEach(function (p) { cnt[p.b] = (cnt[p.b] || 0) + 1; });
    C.brands = Object.keys(cnt).filter(function (b) { return b !== 'BIANCO' && cnt[b] >= 2; })
      .sort(function (a, b) { return cnt[b] - cnt[a]; });

    var LET = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'], lc = {}, nc = {};
    all.forEach(function (p) {
      p.sz.forEach(function (z) { if (LET.indexOf(z) >= 0) lc[z] = (lc[z] || 0) + 1; else nc[z] = (nc[z] || 0) + 1; });
    });
    C.sizes = { letter: LET.filter(function (z) { return lc[z] >= 5; }),
      num: Object.keys(nc).filter(function (z) { return nc[z] >= 6 && /^\d+$/.test(z); })
        .sort(function (a, b) { return a.length - b.length || (a < b ? -1 : a > b ? 1 : 0); }) };

    var ccnt = {}; all.forEach(function (p) { if (p.col_) ccnt[p.col_] = (ccnt[p.col_] || 0) + 1; });
    C.colors = COLOR.filter(function (c) { return ccnt[c[0]] >= 4; }).map(function (c) {
      return { k: c[0], en: c[0].charAt(0).toUpperCase() + c[0].slice(1), ar: c[2], n: ccnt[c[0]] }; });

    // أول صورة طولية = موديل لابس القطعة — من الصورة نفسها مش من ليستة ثابتة
    C.onModel = all.filter(function (p) { return p.ar && p.ar < 0.85; }).map(function (p) { return p.h; });
    C.newest = all.filter(function (p) { return !CS[p.h]; }).sort(newest).slice(0, 40).map(function (p) { return p.h; });
    C.live = true;
  }

  // كل زيارة بتطلب نسخة جديدة: الكاش العادي بتاع شوبيفاي بيفضل يرجّع القديم
  // لحد ٢٠ ثانية بعد التعديل (مجرّب)، والمطلوب إن التعديل يبان على طول
  var stamp = Date.now();
  function get(page) {
    return fetch('/collections/all?view=bn-live&page=' + page + '&t=' + stamp, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('bn-live ' + r.status); return r.json(); });
  }
  function getCol(handle, page) {
    return fetch('/collections/' + handle + '?view=bn-live&page=' + page + '&t=' + stamp, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('bn-live ' + r.status); return r.json(); });
  }
  // ترتيب القسم زي ما هو متظبط في شوبيفاي (Best selling، يدوي...) — الصفحة بتمشي عليه.
  // بيتجاب بس للقسم اللي الصفحة بتعرضه، عشان باقي الصفحات مايتقلوش
  var ORDER = {}, want = [];
  if (document.getElementById('bn-clr-grid')) want.push('clearance');
  var bc = document.body && document.body.getAttribute('data-bn-collection');
  if (bc && want.indexOf(bc) < 0) want.push(bc);
  var orders = want.map(function (h) {
    return getCol(h, 1).then(function (d) {
      var more = [];
      for (var i = 2; i <= (d.pages || 1); i++) more.push(getCol(h, i));
      return Promise.all(more).then(function (rest) {
        ORDER[h] = [d].concat(rest).reduce(function (a, x) {
          return a.concat((x.products || []).map(function (p) { return p.h; })); }, []);
      });
    }).catch(function () {});        // من غير ترتيب — بيفضل الترتيب القديم
  });
  var guess = Math.max(1, Math.ceil(Object.keys(C.products || {}).length / 250));
  var first = [];
  for (var pg = 1; pg <= guess; pg++) first.push(get(pg));
  Promise.all(first).then(function (pages) {
    var total = (pages[0] && pages[0].pages) || guess, more = [];
    for (var i = guess + 1; i <= total; i++) more.push(get(i));
    return Promise.all(more).then(function (rest) {
      return pages.concat(rest).reduce(function (a, d) { return a.concat(d.products || []); }, []);
    });
  }).then(function (list) {
    return Promise.all(orders).then(function () { return list; });
  }).then(function (list) {
    if (!list.length) return;
    merge(list);
    clearTimeout(timer);
    fire();
    try { document.dispatchEvent(new CustomEvent('bn:live')); } catch (e) {}
  }).catch(function () { /* الكتالوج الثابت فضل — التايمر هيرسم بيه */ });
})();
